import { TaskTypeId } from "@/types/Tasks/TaskTypeId";

export interface TasksState {
	// @refactor move to event state
	Tasks: Task[]; // TaskGroup[]; // event-specific, @refactor EventTasks
	TaskTypes: TaskType[];
	TaskCategories: TaskCategory[];
	TaskLibrary: any[]; // @refactor ActionLibrary
	ActionPlans: ActionPlan[];
	ToggleActionListModal: boolean;
	OutstandingRequiredTasks: number;
	NotificationServers: any[];
	NotificationTemplate: NotificationMessageTemplate;
	NotificationTemplates: NotificationMessageTemplate[];
	NotificationContacts: NotificationContacts[];
	EditTriggerAction: any;
	CallContacts: any[];
	DynamicDataList: any[];
	DynamicData: DynamicData[];
	taskTriggers: ActionTrigger[];
}

export interface TaskGroup {
	isNew: boolean;
	tasks: Task[];
	title: string;
}

export interface ActionPlanCreate {
	edit: boolean,
	groupID: number,
	isNew: boolean,
	title: string,
	scriptCategoryID: ActionPlanCategory | null
}

export interface ActionPlan {
	groupID: number,
	scriptID: number,
	title: string,
	mobileSupported?: boolean | null,
	scriptCategoryID: ActionPlanCategory
}

export enum ActionPlanCategory {
	Alarm = 1,
	Assessment = 2,
	Dispatch = 3
}

export interface ActionPlanActions {
	taskID: number;
	taskTypeID: number;
	taskCategoryTitle: string;
	taskText: string;
	mobileSupported: boolean;
}

export interface SelectedActionPlan {
	scriptID: number;
	title: string;
}

export interface TaskType {
	description: string;
	taskTypeID: TaskTypeId;
	title: string;
	taskData?: object;
	titleTextFormat: string;
	componentFile: string;
	mobileSupported: boolean;
}

export interface TaskCategoryType {
	taskCategoryTypeID: TaskCategoryTypeId;
	title: string;
}

export interface TaskCategory {
	taskCategoryID: number;
	title: string;
	tasks: Task[];
	selected: boolean;
	groupID: boolean;
	taskCategoryTypeID?: TaskCategoryTypeId;
}

export enum TaskCategoryTypeId {
	Alarm = 1,
	Assessment = 2,
	Dispatch = 3
}

export interface Task {
	assignedToGroupID?: number | null;
	assignedToUserID?: number | null;
	assignedToEventUserID?: string | null;
	completed: boolean;
	eventID?: number;
	eventTaskID: string;
	isMine: boolean;
	required: boolean;
	result: string | null;
	taskCategoryTitle: string;
	taskID?: number | null;
	taskText: string;
	taskTypeID?: number | null;
	taskData: object;
	guardTourStepId?: number | null;
}

/**
 * Represents the association between a script (action plan) and a task (action library item).
 */
export interface ActionPlanTaskScript {
	order: number;
	required: boolean;
}

/**
 * Represents a task that is part of an action plan/script.
 */
export interface ActionPlanTask {
	isMine: boolean;
	taskCategoryID: number;
	taskID: number;
	taskText: string;
	taskData: any;
	taskTypeID: number;
	eventTaskID: string;

	triggeredTaskCount?: number;
	scripts?: { [scriptId: number]: ActionPlanTaskScript };
	selected?: boolean;

	completed?: boolean;

	eventID?: number;
	result: string;
}

/**
 * Represents an Event Task - a task that is part of an event.
 */
export interface EventTask {
	eventTaskID: string;
	eventID: number;
	taskID?: number | null;
	taskTypeID?: number | null;
	taskCategoryTitle: string;
	taskText: string;
	taskData: any;

	assignedToEventUserID?: string | null;
	assignedToGroupID?: number | null;

	required: boolean;
	isMine: boolean;
	completed: boolean;
	result: string | null;
}

export interface DynamicDataTypes {
	dataTypeId: number;
	groupSyncId?: number;
	groupId?: number,
	name: string;
}

export interface DynamicData {
	dynamicDataId: number;
	dataTypeId: number;
	value: string;
	eventTaskId?: number;
}

export interface QueryDynamicData {
	dynamic: DynamicData[];
	atEnd: boolean;
}

export interface QueryNotificationServers {
	serverId: number,
	searchTerm: string
}

export interface NotificationContacts {
	email: string,
	externalId: string,
	name: string,
	telephone: string,
	userId: number
}

export interface TaskLibrary {
	groupID: number,
	scripts?: { [scriptId: number]: ActionPlanTaskScript } | any,
	selected: boolean,
	taskCategoryID: number,
	taskData?: any,
	taskID: number,
	taskText: string,
	taskTypeID: number,
	triggeredTaskCount: number
}

export interface ActionPayload {
	scriptID: number,
	taskID: number,
	required: boolean,
	order?: number
}

export interface ActionTrigger {
	required: boolean,
	resultCondition: string,
	taskID: number,
	trigger?: any,
	triggerID: string,
	triggerTaskID: number
}

export interface NewActionTrigger {
	required: boolean,
	resultCondition: string,
	taskID: number,
	triggerTaskID: number,
	trigger?: any
}

export interface NewTask {
	title: string;
	groupTitle: string;
	taskTypeID: number | null;
	required: boolean;
	taskID?: number;
	taskCategoryID?: number;
	taskData?: object;
}

export interface NotificationMessageTemplate {
	notificationsMessageTemplateID: number;
	title: string;
	serverID: number;
	message: string;
	subject: string;
	internalParameters: string;
	parameters: null;
	users: null;
}
